import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GridTestComponent } from './grid-test/grid-test.component';
import { TabTestComponent } from './tab-test/tab-test.component';
import { TestComponent } from './test.component';
import { LanguageComponent } from './language/language.component';
import { StyleTestComponent } from './style-test/style-test.component';
import { ContrattiGridTestComponent } from './contratti-grid/contratti-grid-test.component';
import { LoginGuardInjectable } from 'src/app/services/helpers/login-guard-injectable';


const routes: Routes = [
  {path:'',component: TestComponent},
  { path: 'grid', component: GridTestComponent },
  { path: 'contratti', component: ContrattiGridTestComponent },
  {path: 'tabs', component: TabTestComponent, children: [
    {
      path: 'tab1', component: GridTestComponent,
    },
    {
      path: 'tab2', component: TestComponent
    },
    {
      path: 'tab3', component: LanguageComponent
    },
  ]},
  { path: 'style', component: StyleTestComponent, canActivate: [LoginGuardInjectable] }
];
// const routes: Routes = [
//   { path: '', children:[
//     {path:'home', component: TestComponent},
//   ] },
// ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestRoutingModule { }
